package pwgs.ui.scenes.leaderboardlistscene

import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import visage.core.*
import visage.rmi.*
import kotlin.coroutines.CoroutineContext
import kotlin.coroutines.suspendCoroutine
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.launch

abstract class ALeaderboardListControllerFe(props: pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneProps, scene: MLeaderboardListScene)
 : AController<pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneProps, pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel, LeaderboardListSceneState>(props, scene) {

    val backend = LeaderboardListControllerBeProxy(this)
    val coroutineScope = DefaultControllerScope()

    fun launchOnDefaultControllerScope(block: suspend CoroutineScope.() -> Unit) {
        this.coroutineScope.launch(block = block)
    }

    fun call_load() {
        launchOnDefaultControllerScope {
            render(backend.load())
        }
    }

    fun call_showCreateDialog() {
        launchOnDefaultControllerScope {
            render(backend.showCreateDialog())
        }
    }

    fun call_create() {
        launchOnDefaultControllerScope {
            render(backend.create())
        }
    }

    fun call_delete(name: kotlin.String) {
        launchOnDefaultControllerScope {
            render(backend.delete(name))
        }
    }

    class DefaultControllerScope : CoroutineScope {
        private val job = Job()

        override val coroutineContext: CoroutineContext
            get() = Dispatchers.Main + job
    }
}

class LeaderboardListControllerBeProxy(private val controller: ALeaderboardListControllerFe) {

    suspend fun load(): pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.leaderboardlistscene.LeaderboardListControllerBe.load",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel.serializer())
        }
    }

    suspend fun showCreateDialog(): pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.leaderboardlistscene.LeaderboardListControllerBe.showCreateDialog",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel.serializer())
        }
    }

    suspend fun create(): pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel {
        @Serializable
        class ParamsWrapper()
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper())
        val p = RmiParams(
            action = "pwgs.ui.scenes.leaderboardlistscene.LeaderboardListControllerBe.create",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel.serializer())
        }
    }

    suspend fun delete(name: kotlin.String): pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel {
        @Serializable
        class ParamsWrapper(val name: kotlin.String)
        val params: String = Json.encodeToString(ParamsWrapper.serializer(), ParamsWrapper(name))
        val p = RmiParams(
            action = "pwgs.ui.scenes.leaderboardlistscene.LeaderboardListControllerBe.delete",
            methodParams = params,
            props = Json.encodeToString(pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneProps.serializer(), controller.props),
            currentModel = Json.encodeToString(pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel.serializer(), controller.model)
        )
        return suspendCoroutine { res ->
            val promise = RmiClient.call(p)
            RmiClient.handleResult(controller.model, res, promise, pwgs.ui.scenes.leaderboardlistscene.LeaderboardListSceneModel.serializer())
        }
    }

}
